import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

export enum Status {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
export type NewGlossary = {
  glossaryName: string;
  glossaryType: string;
  comment: string;
  description: string;
  status: Status;
  product?: string;
  termVisibility?: string;
};

export type Glossary = {
  glossaryId: string;
  glossaryName: string;
  glossaryType: string;
  comment: string;
  description: string;
  status: Status;
  product?: string;
  termVisibility?: string;
};

@Injectable({
  providedIn: "root",
})
export class GlossaryService {
  private API_URL: string;

  constructor(private http: HttpClient, @Inject("API_URL") apiUrl: string) {
    this.API_URL = apiUrl;
  }

  getGlossary(): Observable<any> {
    return this.http.get<any>(`${this.API_URL}/admin/glossary`);
  }

  createGlossary(body: NewGlossary): Observable<Glossary> {
    return this.http.post<Glossary>(`${this.API_URL}/admin/glossary`, body);
  }

  updateGlossary(body: Glossary): Observable<Glossary> {
    return this.http.post<Glossary>(`${this.API_URL}/admin/glossary`, body);
  }
}
